export default __webpack_public_path__ + "static/media/java.8ee5f981.svg";